/* Fabryk Design — PDP extra: iDEAL-logo in de betaalrij + uitlijning info-popups */
(function () {
  function fdInjectStyle() {
    if (document.getElementById('fd-pdp-extra-style')) return;
    var st = document.createElement('style');
    st.id = 'fd-pdp-extra-style';
    st.textContent =
      '.product-popup{display:flex !important;align-items:center;margin:0 0 7px !important;}' +
      '.product-popup:first-of-type{margin-top:12px;}' +
      '.fd-pay-ideal{display:inline-flex;align-items:center;}' +
      '.fd-pay-ideal svg{display:block;}';
    document.head.appendChild(st);
  }
  function fdAddIdeal() {
    if (!/template-product/.test(document.body.className)) return;
    if (document.querySelector('.fd-pay-ideal')) return;
    var icons = document.querySelectorAll('.icon--full-color');
    if (!icons.length) return;
    var row = null;
    icons.forEach(function (ic) {
      var p = ic.parentElement;
      if (p && p.querySelectorAll('.icon--full-color').length >= 2) row = p;
    });
    if (!row) return;
    var span = document.createElement('span');
    span.className = 'fd-pay-ideal';
    span.innerHTML = '<svg width="38" height="24" viewBox="0 0 38 24" role="img" aria-label="iDEAL" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="37" height="23" rx="3.5" fill="#ffffff" stroke="#e6e6e6"/><text x="5.5" y="16" font-family="Arial,Helvetica,sans-serif" font-size="10" font-weight="700"><tspan fill="#cc0066">i</tspan><tspan fill="#1a1a1a">DEAL</tspan></text></svg>';
    row.insertBefore(span, row.firstChild);
  }
  function run() { fdInjectStyle(); fdAddIdeal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 900);
})();
